var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import sizes from "./sizes";
/**
 * A export icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function ExportIcon(_a) {
    var { size = "small" } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: "middle",
        }, viewBox: "0 0 20 20", fill: "none" }, rest, { children: _jsx("path", { fill: "currentColor", d: "M9 4.694v1H2v13h13v-7h1v7.004a.997.997 0 01-1 .996H2c-.552 0-1-.444-1-.996V5.69a.998.998 0 011-.996h7zm9.5-3c.263 0 .5.237.5.5v5c0 .263-.237.477-.5.477s-.5-.214-.5-.477V3.378l-9.658 9.671a.473.473 0 01-.342.148.496.496 0 01-.354-.845l9.67-9.658H13.5c-.263 0-.477-.237-.477-.5s.214-.5.477-.5z" }) })));
}
//# sourceMappingURL=ExportIcon.js.map